var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccord3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 79,
    viewBox: "0 0 80 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M20 39C31.0457 39 40 30.2696 40 19.5C40 8.73045 31.0457 0 20 0C8.9543 0 0 8.73045 0 19.5C0 30.2696 8.9543 39 20 39Z",
    fill: "#FFF9E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M60 39C71.0457 39 80 30.2696 80 19.5C80 8.73045 71.0457 0 60 0C48.9543 0 40 8.73045 40 19.5C40 30.2696 48.9543 39 60 39Z",
    fill: "#FFF9E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M20 79C31.0457 79 40 70.0457 40 59C40 47.9543 31.0457 39 20 39C8.9543 39 0 47.9543 0 59C0 70.0457 8.9543 79 20 79Z",
    fill: "#FFF9E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M60 79C71.0457 79 80 70.0457 80 59C80 47.9543 71.0457 39 60 39C48.9543 39 40 47.9543 40 59C40 70.0457 48.9543 79 60 79Z",
    fill: "#FFF9E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccord3);
export default __webpack_public_path__ + "static/media/accord_3.da2fd7e8075a8e5bbf08a8ec160acc2d.svg";
export { ForwardRef as ReactComponent };